export const currencyCodesObj = {
  CAD: '124',
  USD: '840',
} as const;

export const getCurrencyCodeByNumber = (currencyNumber?: string): string => {
  switch (currencyNumber) {
    case currencyCodesObj.CAD:
      return 'CAD';
    case currencyCodesObj.USD:
      return 'USD';
    default:
      return 'USD';
  }
};
